/**
 * サービス削除不可アラートの共通文言（2026-07-19 渡辺さん指定）
 * 申込（予約）残り・ページ紐づきの両ケースを1つの文言に統合し、
 * 削除手順のヘルプ記事へ誘導する
 */
export const SERVICE_UNDELETABLE_HELP_URL =
  "https://note.com/eewww/n/n79411004602f";

export const ServiceUnDeletableMessage = () => (
  <>
    このサービスには申込（予約）またはページが残っているため削除できません。
    <br />
    削除手順は
    <a
      href={SERVICE_UNDELETABLE_HELP_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="text-[#3ABCA8] cursor-pointer"
    >
      ヘルプ記事
    </a>
    をご覧ください
  </>
);
